// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type GetDashboardQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type GetDashboardQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { dashboard?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DashboardModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.DashboardModelAsAdminQueries, 'id'>
      & DashboardManageFragment
    )> }
  )> }
);

export type DashboardManageFragment = (
  { __typename?: 'DashboardModelAsAdminQueries' }
  & Pick<PrivateSchemaTypes.DashboardModelAsAdminQueries, 'id' | 'title' | 'color' | 'description' | 'custom_metric' | 'isEditor'>
  & { filters: Array<(
    { __typename?: 'DashboardFilter' }
    & Pick<PrivateSchemaTypes.DashboardFilter, 'created_at' | 'created_by' | 'ref_ids' | 'type'>
    & { comparator?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserFilterComparator' }
      & Pick<PrivateSchemaTypes.UserFilterComparator, 'value' | 'field' | 'operator'>
    )> }
  )>, workspaces: Array<(
    { __typename?: 'WorkspaceModel' }
    & Pick<PrivateSchemaTypes.WorkspaceModel, 'id' | 'name' | 'publishedTopicsCount'>
  )>, topics: Array<(
    { __typename?: 'TopicModel' }
    & Pick<PrivateSchemaTypes.TopicModel, 'id' | 'currentTitle'>
  )>, events: Array<(
    { __typename?: 'EventModel' }
    & Pick<PrivateSchemaTypes.EventModel, 'id' | 'title' | 'start_time' | 'timezone'>
  )>, pathways: Array<(
    { __typename?: 'PathwayModel' }
    & Pick<PrivateSchemaTypes.PathwayModel, 'id' | 'title'>
  )>, campaigns: Array<(
    { __typename?: 'CampaignModel' }
    & Pick<PrivateSchemaTypes.CampaignModel, 'id' | 'name'>
  )>, surveys: Array<(
    { __typename?: 'SurveyModel' }
    & Pick<PrivateSchemaTypes.SurveyModel, 'id' | 'title'>
  )> }
);

export const DashboardManageFragmentDoc = gql`
    fragment dashboardManage on DashboardModelAsAdminQueries {
  id
  title
  color
  description
  custom_metric
  isEditor
  filters {
    comparator {
      value
      field
      operator
    }
    created_at
    created_by
    ref_ids
    type
  }
  workspaces {
    id
    name
    publishedTopicsCount
  }
  topics {
    id
    currentTitle
  }
  events {
    id
    title
    start_time
    timezone
  }
  pathways {
    id
    title
  }
  campaigns {
    id
    name
  }
  surveys {
    id
    title
  }
}
    `;
export const GetDashboardDocument = gql`
    query getDashboard($id: PositiveInt!) {
  admin {
    dashboard(id: $id) {
      id
      ...dashboardManage
    }
  }
}
    ${DashboardManageFragmentDoc}`;

/**
 * __useGetDashboardQuery__
 *
 * To run a query within a React component, call `useGetDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, options);
      }
export function useGetDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, options);
        }
export type GetDashboardQueryHookResult = ReturnType<typeof useGetDashboardQuery>;
export type GetDashboardLazyQueryHookResult = ReturnType<typeof useGetDashboardLazyQuery>;
export type GetDashboardQueryResult = Apollo.QueryResult<GetDashboardQuery, GetDashboardQueryVariables>;